import React, { useEffect, useState } from 'react';
// import {firebaseApp,auth0} from './data/config';
import {
  BrowserRouter, Switch, Route, Redirect,
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { observer } from 'mobx-react';
import { runInAction } from 'mobx';
import {
  requestGet,
} from './services/real.backend';
// import * as serviceWorker from './serviceWorker';

// ** Import custom components for redux **
// import { Provider } from 'react-redux';
// import store from './store';
// import App from "./components/app";
// import { Auth0Provider } from '@auth0/auth0-react'

// Import custom Components
// import Default from './components/dashboard/defaultCompo/default';
// import Ecommerce from './components/dashboard/ecommerce';
// import University from './components/dashboard/university';
// import Crypto from './components/dashboard/crypto/crypto-component';
// import ServerComponent from './components/dashboard/server/server-component';
// import Project from './components/dashboard/project/project';

// widgets
// import General from './components/widgets/general';
// import Chart from './components/widgets/chart';

// Base
// import Statecolor from './components/base/statecolor';
// import Typography from './components/base/typography';
// import Avatar from './components/base/avatar';
// import HelperClass from './components/base/helperclass';
// import Grid from './components/base/grid';
// import TagsandPills from './components/base/tagsandpills';
// import ProgressBar from './components/base/progressBar';
// import ModalComponent from './components/base/modalComponent';
// import AlertComponent from './components/base/Alert/Alert';
// import PopoverComponent from './components/base/Popover/Popover';
// import TooltipsComponent from './components/base/tooltipsComponent';
// import Spinner from './components/base/spinner';
// import DropdownComponent from './components/base/DropDown/Dropdown';
// import TabBootstrap from './components/base/Tabs/TabBootstrap';
// import TabLine from './components/base/Tabs/TabLine';
// import Accordion from './components/base/Accordian/Accordian';
// import Navs from './components/base/Nav/Navs';
// import List from './components/base/lists/list';
// import Shadow from './components/base/shadow';

// Advance
// import Scrollable from './components/advance/scrollable';
// import Toastr from './components/advance/toastr';
// import RatingComponent from './components/advance/ratingComponent';
// import DropzoneComponent from './components/advance/dropzone';
// import TourComponent from './components/advance/tourComponent';
// import SweetAlert from './components/advance/sweetAlert';
// import SlickSlider from './components/advance/slickSlider';
// import CarouselComponent from './components/advance/Carousels/carouselComponent';
// import Ribbon from './components/advance/ribbon';
// import Pagination from './components/advance/pagination';
// import Steps from './components/advance/steps';
// import UIBreadCrumb from './components/advance/uibreadcrumb';
// import RangeSlider from './components/advance/rangeSlider';
// import ImageCropper from './components/advance/imageCropper';
// import StickyNotes from './components/advance/stickyNotes';
// import DragNDropComp from './components/advance/drag-n-drop/dragNDropComp';
// import UploadImage from './components/advance/uploadImage';

// icons
// import FlagIcons from './components/icons/flagIcons';
// import FontAwsomeIcon from './components/icons/fontAwsomeIcon';
// import IcoIcons from './components/icons/icoIcons';
// import ThemifyIcons from './components/icons/themifyIcons';
// import FeatherIcons from './components/icons/featherIcons';
// import WeatherIcons from './components/icons/weatherIcons';

// buttons
// import DefaultBtn from './components/buttons/default-btn';
// import FlatBtn from './components/buttons/flatBtn';
// import EdgeBtn from './components/buttons/edgeBtn';
// import RaisedBtn from './components/buttons/raisedBtn';
// import GroupBtn from './components/buttons/groupBtn';

// gallery
// import ImageGallery from './components/gallery/imageGallery';
// import ImageHover from './components/gallery/imageHover';
// import ImageWithDesc from './components/gallery/imageWithDesc';
// import MesonryGallery from './components/gallery/mesonryGallery';
// import MesonryDesc from './components/gallery/mesonryDesc';

// forms
// import FormValidation from './components/forms/form-control/form-validation';
// import BaseInput from './components/forms/form-control/baseInput';
// import RadioCheckbox from './components/forms/form-control/radio-checkbox';
// import InputGroupComp from './components/forms/form-control/inputGroup';
// import MegaOptions from './components/forms/form-control/megaOptions';
//
// import DatepickerComponent from './components/forms/form-widgets/datepickerComponent';
// import TimePickerWrapper from './components/forms/form-widgets/timepickerComponent/timepicker';
// import TypeaheadComp from './components/forms/form-widgets/typeaheadComponent/typeahead';
//
//
// import FormDefault from './components/forms/form-layout/formDefault';
// import FormWizard from './components/forms/form-layout/wizard/form-wizard';

// tables
// import BasicTable from './components/tables/bootstrap/basicTable';
// import StylingTable from './components/tables/bootstrap/stylingTable';
// import BorderTable from './components/tables/bootstrap/borderTable';
// import SizingTable from './components/tables/bootstrap/sizingTable';
// import DataTableComponent from './components/tables/dataTableComponent';

// cards
// import BasicCards from './components/cards/basicCards';
// import CreativeCards from './components/cards/creativeCards';
// import TabCard from './components/cards/tabCard';
// import DraggingCards from './components/cards/draggingCards';

// timeline
// import Timeline2 from './components/timelines/timeline2';
// import Timeline from './components/timelines/timeline';

// charts
// import GoogleChart from './components/charts/googleChart';
// import ChartJs from './components/charts/chartJs';
// import ChartistComponent from './components/charts/chartistComponent';
// import Knobcharts from './components/charts/knob';

// maps
// import GoogleMap from './components/map/googleMap';
// import LeafletMapComp from './components/map/leafletMap';

// editors
// import Editor1 from './components/editor/ckEditor';
// import Editor2 from './components/editor/mdeEditor';
// import Editor3 from './components/editor/aceCodeEditor';

// users
// import UserProfile from './components/users/userProfile';
// import UserEdit from './components/users/userEdit';
// import UserCards from './components/users/user-cards';

// Calender
// import Calender1 from './components/calender/calender1';
// import Calender2 from './components/calender/calender2';

// blog
// import BlogDetail from './components/blog/blogDetail';
// import BlogSingle from './components/blog/blogSingle';
// import BlogPost from './components/blog/blogPost';

// job search
// import CardView from './components/jobSearch/cardView';
// import JobList from './components/jobSearch/job-list';
// import JobDetail from './components/jobSearch/job-detail';
// import JobApply from './components/jobSearch/job-apply';

// learning
// import LearningList from './components/learning/learning-list';
// import LearningDeatil from './components/learning/learning-deatil';

// pages
// import Login from './pages/login';
// import LoginWithBgImg from './pages/loginWithBgImg';
// import LoginWithVideo from './pages/loginWithVideo';
// import Signup from './pages/signup';
// import SignupWithImg from './pages/signupWithImg';
// import SignupWithVideo from './pages/signupWithVideo';
// import UnlockUser from './pages/unlockUser';
// import ForgetPwd from './pages/forgetPwd';
// import ResetPwd from './pages/resetPwd';
// import ComingSoon from './pages/comingsoon';
// import ComingSoonImg from './pages/comingsoonImg';
// import ComingSoonVideo from './pages/comingsoonVideo';
// import Maintenance from './pages/maintenance';
// import Error400 from './pages/errors/error400';
// import Error401 from './pages/errors/error401';
// import Error403 from './pages/errors/error403';
// import Error500 from './pages/errors/error500';
// import Error503 from './pages/errors/error503';

// Import Applications Components
// import Todo from './components/applications/todo-app/todo';
// import EmailDefault from './components/applications/email-app/emailDefault';
// import Chat from './components/applications/chat-app/chat';
// import EcommerceApp from './components/applications/ecommerce-app/product';
// import AddToCart from './components/applications/ecommerce-app/add-to-cart';
// import WishlistComponent from './components/applications/ecommerce-app/wishlist';
// import ProductDetail from './components/applications/ecommerce-app/product-detail/product-detail';
// import Invoice from './components/applications/ecommerce-app/invoice';
// import Checkout from './components/applications/ecommerce-app/checkout';
// import todoFirebase from './components/applications/todo-firebase-app/todo-firebase';
// import ContactApp from './components/applications/contact-app/contactApp';
// import ProductList from './components/applications/ecommerce-app/product-list';
// import Payment from './components/applications/ecommerce-app/payment';
// import History from './components/applications/ecommerce-app/history';
// import BookmarkApp from './components/applications/bookmark-app/bookmarkApp';
// import TaskApp from './components/applications/task-app/taskApp';
//
// import ProjectApp from './components/applications/project/project'
// import NewProject from './components/applications/project/new-project'
// import ProjectDetails from './components/applications/project/project-details'
// import KanbanBoard from './components/applications/kanban-board/kanbanBoard'
// import FileManager from './components/applications/file-manager/file-manager'
//
// import SocialApp from './components/social-app/socialApp';
// import FaqComponent from './components/faq/faqComponent';
// import KnowledgebaseComponent from './components/knowledgebase/knowledgebaseComponent';
// import SupportTicket from './components/support-ticket/supportTicket';

// search page
// import Searchpage from './components/search/searchpage';

// sample page
// import Samplepage from './components/sample/samplepage';

// Pricing
// import Pricing from './components/price/pricing';

// config data
import configDB from './data/customizer/config';
//
// import Callback from './auth/callback'

import '../sass/override.scss';
import Signin from './auth/Signin';

// Error pages
import Error404 from './pages/errors/error404';
import authStorage from './storages/mobx/authStorage';
import { firebaseApp } from './data/config';
import Loader from './components/loader';
import Error500 from './pages/errors/error500';
import HomePage from './pages/Home/HomePage';
import Error403 from './pages/errors/error403';
import { goFull } from './components/buttons/MaximizeBrowserButton';
import dictionaries from './storages/mobx/dictionaries';
import appState from './storages/mobx/appState';
import firebaseCheckAuth from './storages/external/methods/firebaseCheckAuth';
import backendStorage from './storages/external/backend';
import PasswordRestore from './pages/Auth/PasswordRestore';
import logErrorToMyService from './helpers/logErrorToMyService';
import perfectumStorage from './storages/external/perfectum';

const Dashboard = require('./pages/Dashboard').default;

const Application = () => {
  const abortController = new AbortController();
  useEffect(() => {
    // Загружаем все что нужно
    Promise.all([
      backendStorage.getUserAuthState(),
      dictionaries.loadDictionaries(),
      // backendStorage.firebaseCheckAuth(),
    ])
      .then((allResults) => {
        runInAction(() => {
          appState.ready();
          logErrorToMyService('User statistics', []);
        });
      })
      .catch((e) => {
        runInAction(() => appState.ready());
        logErrorToMyService(e, []);
      });
    return function cleanup() {
      abortController.abort();
    };
  }, []);

  const isLoggedIn = async () => {
    try {
      await new Promise((resolve, reject) => firebaseApp.auth().onAuthStateChanged(
        (user) => {
          if (user) {
            // User is signed in.
            authStorage.authStateChanged(user);
            resolve(user);
          } else {
            // No user is signed in.
            reject('no user logged in');
          }
        },
        // Prevent console error
        (error) => reject(error),
      ));
      return true;
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    const color = localStorage.getItem('color');
    const layout = localStorage.getItem('layout_version') || configDB.data.color.layout_version;
    document.body.classList.add(layout);
    document.getElementById('color').setAttribute('href', `/assets/css/${color}.css`);

    // eslint-disable-next-line
    }, []);

  if (!appState.isReady) return <Loader />;

  return (
    <div className="App">
      <BrowserRouter basename="/">
        <Switch>
          <Route path="/" exact component={authStorage.isLogged ? HomePage : Signin} />
          <Route path="/login" component={Signin} />
          <Route path="/app" component={authStorage.isLogged ? Dashboard : Signin} />
          <Route path="/notfound" component={Error404} />
          <Route path="/500" component={Error500} />
          <Route path="/403" component={Error403} />
          <Route path="/restore/:code" component={PasswordRestore} />
          <Redirect to="/notfound" />
        </Switch>
      </BrowserRouter>
      <ToastContainer />
    </div>

  );
};

export default observer(Application);
